import React from "react";
import useCollapse from "react-collapsed";
import { MdKeyboardArrowDown } from "react-icons/md";

type ContentT = {
  name: string;
  value: string | undefined;
};

type HeaderT = {
  icon: React.ReactNode;
  fieldName: string;
};
type CollapsedContentT = {
  header: HeaderT;
  contents: ContentT[];
  isDisabled: boolean;
};

export default function CollapsedContent({ header, contents, isDisabled }: CollapsedContentT) {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({
    expandStyles: {
      display: "flex",
      flexDirection: "row",
    },
    collapseStyles: {
      display: "flex",
      flexDirection: "row",
    },
  });

  return (
    <div className={`vbz-profile-accordion ${isExpanded && "vbz-profile-accordion-expanded"}`} {...getToggleProps()}>
      <div className="vbz-profile-accordion-header">
        <div>
          {header.icon}
          <p>{header.fieldName}</p>
        </div>
        <MdKeyboardArrowDown
          size={24}
          className={`${
            isExpanded ? "vbz-profile-accordion-svg-animation-open" : "vbz-profile-accordion-svg-animation-close"
          }`}
        />
      </div>
      <div className="vbz-profile-accordion-body" {...getCollapseProps()}>
        <section>
          {contents.map((content) => (
            <div className={`vbz-profile-accordion-item ${isDisabled && "vbz-disabled"}`} key={`idx-${content.name}`}>
              <h4>{content.name}</h4>
              <p>{content.value}</p>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}
